import type { IconProps } from '../types/IconProps.ts';
export const CreditCardDisabled: IconProps = {
    name: 'CreditCardDisabled',
    children: [
        `<path d="M2 10v7c0 1.1.9 2 2 2h7m-9-9V7c0-1.1.9-2 2-2h16a2 2 0 0 1 2 2v3M2 10h20m0 0v1" />`,
        `<circle cx="18" cy="17" r="3" />`,
        `<path d="m16 16 4 2" />`,
    ]
};